// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-btn{
    width: 100%;
}

.custom-card{
    top: 75px !important;   
}
.custom-card label {
    font-weight: 500;
}

.secondary {
    color: rgb(182, 174, 174);
}

.error {
    color: #d61616;
}

.btn-focus-none:focus {
        outline: none !important;
        box-shadow: none !important;
}

.pdfContainer {
    position: relative;
    top: 75px !important;  
    height: 600px !important; 
}

.pdf {
    height: 100% !important;
}
.back-btn-container {
    display: flex;
    justify-content: end;
    margin-bottom: 5px;
}

.back-btn {
    background-color: #B32523 !important;
    color: #fff !important;
    border: 0;
    border-radius: 6px;
    padding: 5px 15px;
}

@media (max-width: 768px) {
    .search-btn{
        width: 90%;
    }
    .defult-button-head {
        width: unset;
        padding: 5px 20px;
    }
}
.jot-help-details-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 16px 18px;
    border-bottom: 1px solid #e5e7eb;
}

.jot-help-subtitle {
    display: block;
    margin-top: 3px;
    color: #6b7280;
    font-size: 13px;
}

.jot-help-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    flex-wrap: wrap;
}

.jot-help-readonly {
    min-height: 38px;
    width: 100%;
    padding: 7px 12px;
    color: #212529;
    background-color: #f8f9fa;
    border: 1px solid #ced4da;
    border-radius: 4px;
    overflow-wrap: anywhere;
}

.jot-help-description {
    min-height: 120px;
    white-space: pre-wrap;
}

.jot-help-remarks {
    min-height: 90px;
    resize: vertical;
}

@media (max-width: 576px) {
    .jot-help-details-header {
        align-items: flex-start;
        flex-direction: column;
    }

    .jot-help-actions {
        width: 100%;
        justify-content: flex-start;
    }
}


.jot-help-document-preview {
    width: 100%;
    min-height: 220px;
    padding: 10px;
    background-color: #f8f9fa;
    border: 1px solid #ced4da;
    border-radius: 4px;
}

.jot-help-document-image {
    display: block;
    max-width: 100%;
    max-height: 420px;
    margin: 0 auto;
    object-fit: contain;
}

.jot-help-document-frame-wrap {
    height: 520px;
    padding: 0;
    overflow: hidden;
}

.jot-help-document-frame {
    width: 100%;
    height: 100%;
    border: 0;
}
.jot-user-card .rdt_TableRow {
    min-height: 58px;
}

.jot-user-toolbar {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
}

.jot-user-search-wrap {
    min-width: 180px;
}

.jot-user-name-cell,
.jot-user-payment-cell {
    display: flex;
    flex-direction: column;
    gap: 3px;
    min-width: 0;
}

.jot-user-name-cell span {
    max-width: 100%;
    overflow: hidden;
    color: #111827;
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.jot-user-name-cell small,
.jot-user-payment-cell small {
    color: #6b7280;
    font-size: 12px;
}

.jot-user-exam-summary {
    display: flex;
    align-items: center;
    gap: 6px;
    max-width: 100%;
    overflow: hidden;
}

.jot-user-level-chip,
.jot-user-more-chip {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 34px;
    height: 26px;
    padding: 0 9px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
}

.jot-user-level-chip {
    color: #1f2937;
    background: #eef2ff;
    border: 1px solid #c7d2fe;
}

.jot-user-more-chip {
    color: #374151;
    background: #f3f4f6;
    border: 1px solid #d1d5db;
}

.jot-user-status-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 72px;
    height: 28px;
    padding: 0 11px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    text-align: center;
}

.jot-user-status-paid {
    color: #155724;
    background-color: #d4edda;
}

.jot-user-status-failed {
    color: #721c24;
    background-color: #f8d7da;
}

.jot-user-status-default {
    color: #383d41;
    background-color: #e2e3e5;
}

.jot-user-expanded-wrap {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 10px;
    width: 100%;
    padding: 12px 16px 16px 58px;
    background: #f8fafc;
    border-top: 1px solid #e5e7eb;
}

.jot-user-exam-card {
    padding: 11px 12px;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
}

.jot-user-exam-card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 8px;
}

.jot-user-exam-meta {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 6px 14px;
    color: #4b5563;
    font-size: 13px;
}

.jot-user-exam-meta span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.jot-user-empty-exams {
    color: #6b7280;
    font-size: 13px;
}

@media (max-width: 992px) {
    .jot-user-toolbar {
        justify-content: flex-start;
    }

    .jot-user-expanded-wrap {
        padding-left: 16px;
    }
}

@media (max-width: 576px) {
    .jot-user-toolbar {
        flex-direction: column;
    }

    .jot-user-search-wrap {
        min-width: 0;
    }

    .jot-user-exam-meta {
        grid-template-columns: 1fr;
    }
}

.jot-user-expand-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    color: #374151;
    background: #ffffff;
    border: 1px solid #d1d5db;
    border-radius: 6px;
}

.jot-user-expand-btn:hover {
    color: #111827;
    background: #f3f4f6;
}

.jot-user-expand-btn:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.18);
}
`, "",{"version":3,"sources":["webpack://./src/pages/layouts/jot/Jot.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;QACQ,wBAAwB;QACxB,2BAA2B;AACnC;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,YAAY;QACZ,iBAAiB;IACrB;AACJ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,2BAA2B;IAC/B;AACJ;;;AAGA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;AACb;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,WAAW;IACX,4BAA4B;IAC5B,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,aAAa;IACb,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8CAA8C;AAClD","sourcesContent":[".search-btn{\r\n    width: 100%;\r\n}\r\n\r\n.custom-card{\r\n    top: 75px !important;   \r\n}\r\n.custom-card label {\r\n    font-weight: 500;\r\n}\r\n\r\n.secondary {\r\n    color: rgb(182, 174, 174);\r\n}\r\n\r\n.error {\r\n    color: #d61616;\r\n}\r\n\r\n.btn-focus-none:focus {\r\n        outline: none !important;\r\n        box-shadow: none !important;\r\n}\r\n\r\n.pdfContainer {\r\n    position: relative;\r\n    top: 75px !important;  \r\n    height: 600px !important; \r\n}\r\n\r\n.pdf {\r\n    height: 100% !important;\r\n}\r\n.back-btn-container {\r\n    display: flex;\r\n    justify-content: end;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.back-btn {\r\n    background-color: #B32523 !important;\r\n    color: #fff !important;\r\n    border: 0;\r\n    border-radius: 6px;\r\n    padding: 5px 15px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .search-btn{\r\n        width: 90%;\r\n    }\r\n    .defult-button-head {\r\n        width: unset;\r\n        padding: 5px 20px;\r\n    }\r\n}\r\n.jot-help-details-header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 16px;\r\n    padding: 16px 18px;\r\n    border-bottom: 1px solid #e5e7eb;\r\n}\r\n\r\n.jot-help-subtitle {\r\n    display: block;\r\n    margin-top: 3px;\r\n    color: #6b7280;\r\n    font-size: 13px;\r\n}\r\n\r\n.jot-help-actions {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n    gap: 10px;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.jot-help-readonly {\r\n    min-height: 38px;\r\n    width: 100%;\r\n    padding: 7px 12px;\r\n    color: #212529;\r\n    background-color: #f8f9fa;\r\n    border: 1px solid #ced4da;\r\n    border-radius: 4px;\r\n    overflow-wrap: anywhere;\r\n}\r\n\r\n.jot-help-description {\r\n    min-height: 120px;\r\n    white-space: pre-wrap;\r\n}\r\n\r\n.jot-help-remarks {\r\n    min-height: 90px;\r\n    resize: vertical;\r\n}\r\n\r\n@media (max-width: 576px) {\r\n    .jot-help-details-header {\r\n        align-items: flex-start;\r\n        flex-direction: column;\r\n    }\r\n\r\n    .jot-help-actions {\r\n        width: 100%;\r\n        justify-content: flex-start;\r\n    }\r\n}\r\n\r\n\r\n.jot-help-document-preview {\r\n    width: 100%;\r\n    min-height: 220px;\r\n    padding: 10px;\r\n    background-color: #f8f9fa;\r\n    border: 1px solid #ced4da;\r\n    border-radius: 4px;\r\n}\r\n\r\n.jot-help-document-image {\r\n    display: block;\r\n    max-width: 100%;\r\n    max-height: 420px;\r\n    margin: 0 auto;\r\n    object-fit: contain;\r\n}\r\n\r\n.jot-help-document-frame-wrap {\r\n    height: 520px;\r\n    padding: 0;\r\n    overflow: hidden;\r\n}\r\n\r\n.jot-help-document-frame {\r\n    width: 100%;\r\n    height: 100%;\r\n    border: 0;\r\n}\r\n.jot-user-card .rdt_TableRow {\r\n    min-height: 58px;\r\n}\r\n\r\n.jot-user-toolbar {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 12px;\r\n}\r\n\r\n.jot-user-search-wrap {\r\n    min-width: 180px;\r\n}\r\n\r\n.jot-user-name-cell,\r\n.jot-user-payment-cell {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 3px;\r\n    min-width: 0;\r\n}\r\n\r\n.jot-user-name-cell span {\r\n    max-width: 100%;\r\n    overflow: hidden;\r\n    color: #111827;\r\n    font-weight: 600;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.jot-user-name-cell small,\r\n.jot-user-payment-cell small {\r\n    color: #6b7280;\r\n    font-size: 12px;\r\n}\r\n\r\n.jot-user-exam-summary {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    max-width: 100%;\r\n    overflow: hidden;\r\n}\r\n\r\n.jot-user-level-chip,\r\n.jot-user-more-chip {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    min-width: 34px;\r\n    height: 26px;\r\n    padding: 0 9px;\r\n    border-radius: 999px;\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n    line-height: 1;\r\n    white-space: nowrap;\r\n}\r\n\r\n.jot-user-level-chip {\r\n    color: #1f2937;\r\n    background: #eef2ff;\r\n    border: 1px solid #c7d2fe;\r\n}\r\n\r\n.jot-user-more-chip {\r\n    color: #374151;\r\n    background: #f3f4f6;\r\n    border: 1px solid #d1d5db;\r\n}\r\n\r\n.jot-user-status-badge {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    min-width: 72px;\r\n    height: 28px;\r\n    padding: 0 11px;\r\n    border-radius: 999px;\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n    line-height: 1;\r\n    text-align: center;\r\n}\r\n\r\n.jot-user-status-paid {\r\n    color: #155724;\r\n    background-color: #d4edda;\r\n}\r\n\r\n.jot-user-status-failed {\r\n    color: #721c24;\r\n    background-color: #f8d7da;\r\n}\r\n\r\n.jot-user-status-default {\r\n    color: #383d41;\r\n    background-color: #e2e3e5;\r\n}\r\n\r\n.jot-user-expanded-wrap {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\r\n    gap: 10px;\r\n    width: 100%;\r\n    padding: 12px 16px 16px 58px;\r\n    background: #f8fafc;\r\n    border-top: 1px solid #e5e7eb;\r\n}\r\n\r\n.jot-user-exam-card {\r\n    padding: 11px 12px;\r\n    background: #ffffff;\r\n    border: 1px solid #e5e7eb;\r\n    border-radius: 6px;\r\n}\r\n\r\n.jot-user-exam-card-head {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 8px;\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.jot-user-exam-meta {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    gap: 6px 14px;\r\n    color: #4b5563;\r\n    font-size: 13px;\r\n}\r\n\r\n.jot-user-exam-meta span {\r\n    min-width: 0;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.jot-user-empty-exams {\r\n    color: #6b7280;\r\n    font-size: 13px;\r\n}\r\n\r\n@media (max-width: 992px) {\r\n    .jot-user-toolbar {\r\n        justify-content: flex-start;\r\n    }\r\n\r\n    .jot-user-expanded-wrap {\r\n        padding-left: 16px;\r\n    }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n    .jot-user-toolbar {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .jot-user-search-wrap {\r\n        min-width: 0;\r\n    }\r\n\r\n    .jot-user-exam-meta {\r\n        grid-template-columns: 1fr;\r\n    }\r\n}\r\n\r\n.jot-user-expand-btn {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 32px;\r\n    height: 32px;\r\n    color: #374151;\r\n    background: #ffffff;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 6px;\r\n}\r\n\r\n.jot-user-expand-btn:hover {\r\n    color: #111827;\r\n    background: #f3f4f6;\r\n}\r\n\r\n.jot-user-expand-btn:focus {\r\n    outline: none;\r\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.18);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
